import React from 'react'

const ExclamationIcon = () => {
  return (
    <div>
 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14 3H10V15H14V3ZM14 19C14 20.1046 13.1046 21 12 21C10.8954 21 10 20.1046 10 19C10 17.8954 10.8954 17 12 17C13.1046 17 14 17.8954 14 19Z" fill="#A8A8A8"/>
</svg>


    </div>
  )
}

export default ExclamationIcon
